import { Chip } from "../../design-v2";

export default function ChipSelector({
  options,
  selectedValues,
  onToggle,
  maxSelected,
  emptyLabel,
  grouped = false,
  disabledValues = [],
}) {
  const disabledValueSet = new Set(disabledValues);

  function isOptionDisabled(option, isSelected) {
    return (
      disabledValueSet.has(option.value) ||
      (!isSelected &&
        typeof maxSelected === "number" &&
        selectedValues.length >= maxSelected)
    );
  }

  function renderChip(option) {
    const isSelected = selectedValues.includes(option.value);

    return (
      <Chip
        key={option.value}
        selected={isSelected}
        disabled={isOptionDisabled(option, isSelected)}
        onClick={() => onToggle(option.value)}
      >
        {option.label}
      </Chip>
    );
  }

  if (grouped) {
    return (
      <div className="space-y-4">
        {options.map((group) => (
          <div key={group.label} className="lz-settings-chip-group">
            <p className="lz-settings-chip-group__label">{group.label}</p>
            <div className="lz-settings-chip-row">
              {group.options.map(renderChip)}
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (!options.length && emptyLabel) {
    return <p className="lz-settings-muted-text">{emptyLabel}</p>;
  }

  return <div className="lz-settings-chip-row">{options.map(renderChip)}</div>;
}
